function adjustHeightsByRowAuto(options) {
  const { itemSelector, objectPrefix = "c-oj-" } = options;
  let resizeTimeout;

  function resizeHandler() {
    const $allItems = $(itemSelector);
    const $visibleItems = $allItems.filter(function () {
      return $(this).is(":visible");
    });

    if (!$visibleItems.length) return;

    const $firstItem = $visibleItems.eq(0);
    const classes = $firstItem
      .find(`[class*="${objectPrefix}"]`)
      .map(function () {
        return $(this)
          .attr("class")
          .split(" ")
          .filter((cls) => cls.startsWith(objectPrefix));
      })
      .get()
      .flat();

    const selectors = [...new Set(classes)].map((cls) => "." + cls);

    // reset heights
    $visibleItems.each(function () {
      selectors.forEach((selector) => {
        $(this).find(selector).css("height", "");
      });
    });

    const rows = groupItemsByRow($visibleItems);

    rows.forEach((rowItems) => {
      const maxHeights = {};
      selectors.forEach((selector) => {
        maxHeights[selector] = 0;
        rowItems.each(function () {
          const $el = $(this).find(selector);
          if ($el.length) {
            $el.css("height", "");
            maxHeights[selector] = Math.max(maxHeights[selector], $el.outerHeight());
          }
        });
      });

      rowItems.each(function () {
        selectors.forEach((selector) => {
          $(this)
            .find(selector)
            .css("height", maxHeights[selector] + "px");
        });
      });
    });
  }

  function debounceResizeHandler() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(resizeHandler, 100);
  }

  function groupItemsByRow($items) {
    const rows = [];
    let currentTop = null;
    let currentRow = $();

    $items.each(function () {
      const $item = $(this);
      const top = $item.offset().top;

      if (currentTop === null || top === currentTop) {
        currentRow = currentRow.add($item);
        currentTop = top;
      } else {
        rows.push(currentRow);
        currentRow = $item;
        currentTop = top;
      }
    });

    if (currentRow.length) rows.push(currentRow);
    return rows;
  }

  $(window).on("resize", debounceResizeHandler);
  $(window).on("load", debounceResizeHandler);
}

// 実行
adjustHeightsByRowAuto({
  itemSelector: ".c-FxItem",
  objectPrefix: "c-FxOj-",
});
